import {
  CaretLeft,
  CaretRight,
  Envelope,
  Phone,
  User,
  X,
} from 'phosphor-react';
import { string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMobileMenuOpen } from '../Actions/Navigation.action';
import { translate } from '../Services/translation';
import SideMenu from './SideMenu';

const NavigationMobile = () => {
  const dispatch = useDispatch();
  const {
    mobileMenuOpen,
    contentLinks,
    mobileAdditionalLinks,
    myPagesLink,
    phone,
    email,
    logoUrl,
    isB2B,
  } = useSelector((state) => state.navigation);
  const [currentLink, setCurrentLink] = useState();
  const [previousLink, setPreviousLink] = useState();
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (mobileMenuOpen) {
      setCurrentLink(null);
    }
  }, [mobileMenuOpen]);

  const onLinkClick = (link) => {
    link.previousLink = previousLink;
    setPreviousLink(currentLink);
    setCurrentLink(link);
    setLevel(level + 1);
  };

  const onBackClick = () => {
    setPreviousLink(previousLink?.previousLink);
    setCurrentLink(previousLink);
    setLevel(level - 1);
  };
  const onClose = () => {
    dispatch(setMobileMenuOpen(false));
    setLevel(0);
  };

  const links = (currentLink?.links ?? contentLinks).filter(
    (l) => !l.rightAligned
  );

  const extraLinks = isB2B
    ? mobileAdditionalLinks?.filter((l) => l.hideOnB2B != true)
    : mobileAdditionalLinks?.filter((l) => l.hideOnB2C != true);

  const header = (
    <>
      {!currentLink && <img src={logoUrl} alt="Logo" />}
      {currentLink && (
        <div className="navigation-mobile__back" onClick={onBackClick}>
          <CaretLeft size={20} /> {translate('mobile-menu.go-back')}
        </div>
      )}
    </>
  );
  const showFooter =
    !currentLink &&
    (phone || email || myPagesLink || mobileAdditionalLinks?.length > 0);

  return (
    <SideMenu
      from="left"
      id="navigation-mobile"
      open={mobileMenuOpen}
      onClosed={() => onClose()}
      header={header}
      className="side-menu--navigation-mobile"
      closeButton={
        <X size={24} cursor="pointer" className="side-menu__close-button" />
      }
    >
      <div className="navigation-mobile__links">
        {links.map((link, index) => (
          <MobileNavigationItem
            level={level}
            link={link}
            key={'mobile' + link.url + link.name + index}
            onClick={onLinkClick}
          />
        ))}
        {level > 0 && (
          <div className="navigation-mobile__link navigation-mobile__link--sublink ">
            <a href={currentLink?.url}>{translate('mobile-menu.show-all')}</a>
          </div>
        )}
      </div>
      {showFooter && (
        <div className="navigation-mobile__footer">
          {myPagesLink && (
            <div className="navigation-mobile__footer-link">
              <a href={myPagesLink.href}>
                <User /> {myPagesLink.text}
              </a>
            </div>
          )}
          {phone && (
            <div className="navigation-mobile__footer-link">
              <a href={`tel:${phone}`}>
                <Phone /> {phone}
              </a>
            </div>
          )}
          {email && (
            <div className="navigation-mobile__footer-link">
              <a href={`mailto:${email}`}>
                <Envelope /> {email}
              </a>
            </div>
          )}
          {extraLinks?.length > 0 &&
            extraLinks.map((link) => (
              <div
                key={'mobile-additional' + link.url + link.name}
                className="navigation-mobile__footer-link"
              >
                <a href={link.url}>
                  {link.iconUrl && <img alt="" src={link.iconUrl} />}
                  {link.name}
                </a>
              </div>
            ))}
        </div>
      )}
    </SideMenu>
  );
};

const MobileNavigationItem = ({ link, onClick, level }) => (
  <>
    {link.name && (
      <div
        className={`navigation-mobile__link ${
          !link.url ? 'navigation-mobile__link--header' : ''
        }`}
      >
        {level == 0 && link.links?.length > 0 ? (
          <a onClick={() => onClick && onClick(link)}>{link.name}</a>
        ) : (
          <a href={link.url}>{link.name}</a>
        )}
        {level == 0 && link.links?.length > 0 && (
          <div
            className="navigation-mobile__next-level-button"
            onClick={() => onClick && onClick(link)}
          >
            <CaretRight size={20} />
          </div>
        )}
      </div>
    )}
    {level > 0 &&
      link.links?.length > 0 &&
      link.links.map((subLink, index) => (
        <div
          key={subLink.url + subLink.name + index}
          className="navigation-mobile__link navigation-mobile__link--sublink "
        >
          <a href={subLink.url}>{subLink.name}</a>
        </div>
      ))}
  </>
);

export default NavigationMobile;
